import { render, staticRenderFns } from "./ContinueToOrder.vue?vue&type=template&id=5674da9e&"
import script from "./ContinueToOrder.vue?vue&type=script&lang=ts&"
export * from "./ContinueToOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports